module.exports = "<div *ngIf=\"Control\" style=\"font-size: 14px;\">\r\n  <label>{{Control.value}}</label>\r\n</div>\r\n"